export default __webpack_public_path__ + "static/media/004-check.cff70d65.svg";